<script>
import TableWithPagination from '../table-with-pagination';
import {addQueryParams} from '../../libs/url';
import ActionsColumn from './actions-column';
import eventBus from '../../event-bus';
import UserColumn from './columns/user-column';
import SubjectColumn from './columns/subject-column';
import BodyColumn from './columns/body-column';

export default {
  extends: TableWithPagination,

  components: {
    ActionsColumn,
    UserColumn,
    SubjectColumn,
    BodyColumn,
  },

  data() {
    return {
      search: null,
      filters: {},
      isBusy: false,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, this.filters);
    },
  },

  watch: {
    search(current, previous) {
      this.filters = current
          ? _.assign({}, this.filters, {search: current})
          : this.filters = _.omit(this.filters, ['search']);
    },
  },

  methods: {
    /**
     * @param {object} row
     * @param {object} col
     * @param {string} datetime
     * @return {string}
     */
    formatDate(row, col, {datetime}) {
      return moment(datetime).format(config('format.moment.short.datetime'));
    },

    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },

    /**
     * @emits show-email-quarantine-form-dialog
     */
    onApprove({url}) {
      eventBus.$emit('show-email-quarantine-form-dialog', url);
    },

    /**
     * @param {string} url
     */
    onDelete({url}) {
      this.isBusy = true;
      axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          })
          .then(() => this.isBusy = false);
    },
  }
}
</script>
